export default __webpack_public_path__ + "static/media/cp_geo_lv.458e99b7.svg";